(function () {
    "use strict";

    document.addEventListener('click', function (e) {
        const seeMore = e.target.closest('.woocommerce-Tabs-panel--additional_information .attributes-trigger--see-more');
        if (seeMore) {
            const panel = seeMore.closest('.woocommerce-Tabs-panel--additional_information');
            if (panel) {
                const wrapper = panel.querySelector('.product-addination-information-wrapper');
                if (wrapper) wrapper.classList.remove('cropped');
                const hideBtn = panel.querySelector('.attributes-trigger--hide');
                if (hideBtn) hideBtn.style.display = 'block';
            }
            seeMore.style.display = 'none';
            return;
        }

        const hideBtn = e.target.closest('.woocommerce-Tabs-panel--additional_information .attributes-trigger--hide');
        if (hideBtn) {
            const panel = hideBtn.closest('.woocommerce-Tabs-panel--additional_information');
            if (panel) {
                const wrapper = panel.querySelector('.product-addination-information-wrapper');
                if (wrapper) wrapper.classList.add('cropped');
                const seeMore = panel.querySelector('.attributes-trigger--see-more');
                if (seeMore) seeMore.style.display = 'block';
            }
            hideBtn.style.display = 'none';
            return;
        }
    });

    const init = () => {
        const additionalInformationTrigger = document.querySelector('.woocommerce-Tabs-panel--additional_information .attributes-trigger--see-more');
        if (!additionalInformationTrigger) return;
        const panel = additionalInformationTrigger.closest('.woocommerce-Tabs-panel--additional_information');
        if (!panel) return;
        const wrapper = panel.querySelector('.product-addination-information-wrapper');
        if (!wrapper) return;
        wrapper.classList.add('cropped');

        const table = wrapper.querySelector('table');
        if (table && wrapper.offsetHeight >= table.offsetHeight) {
            wrapper.classList.remove('cropped');
            additionalInformationTrigger.style.display = 'none';
        }
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
